import { Text } from '@fluentui/react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import '../../css/immocom.css';
import { DataOperation } from '../../data/DataOperation.jsx';
import perspectiveDefaut from '../../images/PerspectiveDefaut.jpg';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { FicheChecklistItems_Operation } from '../Fiche/FicheChecklistItems_Operation';
import { FicheElementsContratReservation } from '../Fiche/FicheElementsContratReservation';
import { FicheIdentification } from '../Fiche/FicheIdentification';
import { FicheIdentificationEngagement } from '../Fiche/FicheIdentificationEngagement';
import { FicheIdentificationNomenclature } from '../Fiche/FicheIdentificationNomenclature';
import { FicheIdentificationPlanning } from '../Fiche/FicheIdentificationPlanning';
import { FicheIdentificationVente } from '../Fiche/FicheIdentificationVente';
import { FicheValidationCycleCommercial } from '../Fiche/FicheValidationCycleCommercial';
import { FicheValidationCycleOperation } from '../Fiche/FicheValidationCycleOperation';
import { DetailsListDemande } from '../List/DetailsListDemande';
import { DetailsListEcheancier } from '../List/DetailsListEcheancier';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { ModalOperationDates } from '../Modal/ModalOperationDates';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';
import { Timeline } from '../Timeline/Timeline';
import './Identification.css';
import BlocIntervenants from './IdentificationOperation/BlocIntervenants';

export class IdentificationOperation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <IdentificationOperationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class IdentificationOperationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    constructor(props) {
        super(props);

        //this._selectionIntervenant = new Selection({
        //    onSelectionChanged: () => this._getSelectionIntervenants()
        //});

        this.state = {
            operation: {},
            engagementActualiseNb: null,
            engagementActualiseCA: null,
            engagementActualiseSurface: null,
            operationCycle: null,
            operationCycleCommercial: null,
            region: null,
            agence: null,
            nbLots: 0,
            nbPkgSS: 0,
            nbPkgEXT: 0,
            listTva: [],
            prixMaitrise: null,
            listIntervenants: [],
            perfEnergetiques: null,
            certification: null,
            typeChauffage: null,
            natureChauffage: null,
            typeProgramme: null,
            programme: {},
            produit: null,
            sousProduit: null,
            trancheTravaux: {},
            typeVente: null,
            typeContrat: null,
            periodeOuverture: {},
            photo: null,

            listCycleOperation: [],

            //optionsIntervenantPersonne: [],
            //optionsIntervenantSociete: [],
            //optionsCategorieIntervenant: [],

            //selectedIntervenants: [],
            //selectedCategorieIntervenant: null,
            //selectedIntervenantSociete: 0,
            //selectedIntervenantPersonne: 0,
            //selectedIdCycleOperation: 0,

            affichageIdentification: true,
            affichageIntervenants: false,
            affichageEcheancier: false,
            affichageVente: false,
            affichageDemandes: false,

            onAffichePanelIdentification: false,
            onAffichePanelIdentificationVente: false,
            onAffichePanelElementsContratReservation: false,
            //onAffichePanelCategorieIntervenant: false,
            //onAffichePanelIntervenantSociete: false,
            //onAffichePanelIntervenantPersonne: false,
            onAffichePanelValidationCycleOperation: false,
            onAffichePanelValidationCycleCommercial: false,
            //onAfficheDialogIntervenants: false,

            onPeutChargerLeComposantFicheIdentification: false,
            onPeutChargerLeComposantFicheIdentificationVente: false,
            onPeutChargerLeComposantFicheElementsContratReservation: false,
            onPeutChargerLeComposantFicheIntervenantPersonne: false,
            onPeutChargerLeComposantFicheIntervenantSociete: false,

            redirect: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',

            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: ''
        }

        //#region chargement des colonnes
        //let columnsTemp = [];
        //columnsTemp.push({
        //    key: 'categorie',
        //    name: 'Catégorie',
        //    fieldName: 'categorie',
        //    minWidth: 40,
        //    maxWidth: 60,
        //    isResizable: true,
        //    isFiltered: false,
        //    onRender: (item) => {
        //        let categorie = item.categorie;
        //        return <span title={categorie}>{categorie}</span>;
        //    }
        //});

        //columnsTemp.push({
        //    key: 'nom',
        //    name: 'Nom',
        //    fieldName: 'nom',
        //    minWidth: 50,
        //    maxWidth: 100,
        //    isResizable: true,
        //    isFiltered: false,
        //    onRender: (item) => {
        //        let nom = item.nom;
        //        return <span title={nom}>{nom}</span>;
        //    }
        //});

        //this.columns = columnsTemp;
    }

    _creationContent = () => {
        let sectionAAfficher = null;

        if (this.state.affichageIdentification) {
            sectionAAfficher = this._creationSectionIdentification();
        }
        else if (this.state.affichageIntervenants) {
            sectionAAfficher = this._creationSectionIntervenants();
        }
        else if (this.state.affichageEcheancier) {
            sectionAAfficher = this._creationSectionEcheancier();
        }
        else if (this.state.affichageVente) {
            sectionAAfficher = this._creationSectionVente();
        }
        else if (this.state.affichageDemandes) {
            sectionAAfficher = this._creationSectionDemandes();
        }

        // Attention, les idCycleOperation vont de 10 en 10 alors que les étapes de la timeline vont de 1 en 1 : d'où la / par 10
        return <Stack verticalFill>
            <Timeline listeEtapes={this.state.listCycleOperation} etapeActive={(this.state.operationCycle !== null ? this.state.operationCycle.idCycleOperation / 10 : 0)} />
            <nav className="navbar navbar-expand-lg navbar-light border-bottom">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavFicheReservation" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavFicheReservation">
                    <ul className="navbar-nav">
                        <li className={`nav-item itemNavigationIdentification ${(this.state.affichageIdentification ? 'active' : '')}`} onClick={this._onSelectionOnglet("Identification")}>Identification</li>
                        <li name="liIntervenants" className={`nav-item itemNavigationIdentification ${(this.state.affichageIntervenants ? 'active' : '')}`} onClick={this._onSelectionOnglet("Intervenants")}>Intervenants</li>
                        <li name="liEcheancier" className={`nav-item itemNavigationIdentification ${(this.state.affichageEcheancier ? 'active' : '')}`} onClick={this._onSelectionOnglet("Echeancier")}>échéancier</li>
                        <li name="liVente" className={`nav-item itemNavigationIdentification ${(this.state.affichageVente ? 'active' : '')}`} onClick={this._onSelectionOnglet("Vente")}>Vente</li>
                        {this.state.afficherOngletDemandes && <li className={`nav-item itemNavigationIdentification ${(this.state.affichageDemandes ? 'active' : '')}`} onClick={this._onSelectionOnglet("Demandes")}>Demandes</li>}
                        {this.state.afficherOngletChecklist && <li className={`nav-item itemNavigationIdentification`} onClick={() => this.setState({ onAffichePanelChecklist: true })}>Checklist</li>}
                    </ul>
                </div>
            </nav>
            {sectionAAfficher}
        </Stack>;
    }

    _creationSectionIdentification = () => {

        /* 20231220 : YD : 2532 : si pas engagementActualiseCA => engagementInitialCA, idem pour engagementActualiseNb et engagementActualiseSurface 
         * modification des tests pour affichage des libellés
         */

        const { engagementActualiseCA, engagementActualiseNb, engagementActualiseSurface, listTva, nbLots, nbPkgEXT, nbPkgSS, operation } = this.state;
        const { engagementInitialCA, engagementInitialNb, qpEI, shA } = operation;

        const currencyFormat = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
        const percentFormat = new Intl.NumberFormat("fr-FR", { style: "percent", minimumFractionDigits: 0 });

        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg3">
                    {/* Section : engagement */}
                    <div className="ms-Grid blocIdentification niveau3">
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12" name="divEditEngagement">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        <Icon iconName="Commitments" className="mr-2" />Engagement
                                    </div>
                                    <Stack horizontal>
                                        <HintWrapper
                                            content={
                                                <Stack>
                                                    <Text>Eng. initial Nb : {engagementInitialNb}</Text>
                                                    <Text>Eng. initial surface (SHA / SU) : {!!shA || shA === 0 ? parseFloat(shA).toFixed(2) + ' m²' : null}</Text>
                                                    <Text>Eng. initial CA : {!!engagementInitialCA || engagementInitialCA === 0 ? currencyFormat.format(engagementInitialCA) : null}</Text>
                                                </Stack>
                                            }
                                            verticalAlign={HintVerticalPosition.center}
                                        />
                                        <IconButton id="btnEditEngagement" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationEngagement} />
                                    </Stack>
                                </Stack>
                            </div>
                        </div>

                        <EUIDetailsList
                            compact
                            columns={[{ key: "label", minWidth: 200, maxWidth: 200 }, { key: "value" }]}
                            hideCommandBar
                            hideHeader
                            items={[
                                {
                                    label: "Quote-part initiale",
                                    value: !!qpEI || qpEI === 0 ? percentFormat.format((qpEI) / 100) : null
                                },
                                {
                                    label: `Eng. ${engagementActualiseNb != null ? "actualisé" : "initial"} nb`,
                                    value: engagementActualiseNb != null ? engagementActualiseNb :
                                        engagementInitialNb != null ? engagementInitialNb : null
                                },
                                {
                                    label: `Eng. ${engagementActualiseSurface != null ? "actualisé" : "initial"} surface (SHA / SU)`,
                                    value: engagementActualiseSurface != null ? `${parseFloat(engagementActualiseSurface).toFixed(2)} m²` :
                                        shA != null ? `${parseFloat(shA).toFixed(2)} m²` : null
                                },
                                {
                                    label: `Eng. ${engagementActualiseCA != null ? "actualisé" : "initial"} CA`,
                                    value: engagementActualiseCA != null ? currencyFormat.format(engagementActualiseCA) :
                                        engagementInitialCA != null ? currencyFormat.format(engagementInitialCA) : null
                                },
                                { label: "Logements", value: nbLots },
                                { label: "Parkings sous-sol", value: nbPkgSS },
                                { label: "Parkings extérieurs", value: nbPkgEXT },
                            ]}
                            onRenderRow={(props, defaultRender) => {
                                // Permet d'avoir un séparateur
                                if (!!props && props.itemIndex === 3) {
                                    const styles = { root: { borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "rgba(0, 0, 0, 0.1)" } };
                                    return defaultRender({ ...props, styles })
                                }
                                else return defaultRender(props);
                            }}
                            selectionMode={SelectionMode.none}
                            wrapInScrollablePane={false}
                        />

                        <hr />

                        {/* Section : nomenclature */}
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        <Icon iconName="EMI" className="mr-2" />Nomenclature
                                    </div>
                                    <IconButton name="btnEditNomenclature" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationNomenclature} />
                                </Stack>
                            </div>
                        </div>

                        <EUIDetailsList
                            compact
                            columns={[{ key: "label", minWidth: 200, maxWidth: 200 }, { key: "value" }]}
                            hideCommandBar
                            hideHeader
                            items={[
                                { label: "Région", value: this.state.region },
                                { label: "Agence", value: this.state.agence },
                                { label: "Programme", value: this.state.programme.programme },
                                { label: "Tranche travaux", value: this.state.trancheTravaux.trancheTravaux },
                                { label: "Produit", value: this.state.produit },
                                { label: "Sous-produit", value: this.state.sousProduit },
                                { label: "Type de vente", value: this.state.typeVente },
                                { label: "Type de contrat", value: this.state.typeContrat },
                            ]}
                            onRenderRow={(props, defaultRender) => {
                                // Permet d'avoir un séparateur
                                if (!!props && (props.itemIndex === 1 || props.itemIndex === 5)) {
                                    const styles = { root: { borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "rgba(0, 0, 0, 0.1)" } };
                                    return defaultRender({ ...props, styles })
                                }
                                else return defaultRender(props);
                            }}
                            selectionMode={SelectionMode.none}
                            wrapInScrollablePane={false}
                        />
                    </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-lg5">
                    <div className="ms-Grid">
                        <div className="ms-Grid-row blocIdentificatioPrincipal">
                            <div className="ms-Grid-col ms-sm12 divEncartIdentificationPrincipal divEncartIdentificationPrincipalOperation">
                                <Stack horizontal>
                                    {/* Titre + adresse */}
                                    <Stack.Item grow>
                                        <div className="titreEncart">
                                            <Icon iconName="Home" /> {this.state.operation.nomOperation} {this.state.operation.libelleRegroupement !== null && this.state.operation.libelleRegroupement !== undefined && `(${this.state.operation.libelleRegroupement})`}
                                        </div>
                                        {this.state.operation.adresse} {this.state.operation.complementAdresse !== null && this.state.operation.complementAdresse !== undefined ? `, ${this.state.operation.complementAdresse}` : ''} - {this.state.operation.cp} {this.state.operation.ville}
                                    </Stack.Item>
                                    {/* Badges */}
                                    <Stack gap={1} className="divStatutOperation">
                                        <div className="titreCycleCommercial">Cycle commercial</div>
                                        <Stack horizontal>
                                            <div className="badge badge-secondary badgeCycleCommercial">{this.state.operationCycleCommercial !== null ? (this.state.operationCycleCommercial.idCycleCommercial > 0 ? this.state.operationCycleCommercial.libelle : 'Non activé') : 'Non activé'}</div>
                                            <IconButton iconProps={{ iconName: 'Edit' }} className="boutonEditionCycleCommercial" title="Modifier le cycle commercial" onClick={() => this._onAffichePanelCycleCommercial(this.state.operationCycleCommercial !== null ? this.state.operationCycleCommercial.idCycleCommercial : 0)} />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <div className="badge badge-warning badgeAbandon" title={this.state.operation.dateAbandon !== null ? Scriba.date().stringDateFormatCourt(this.state.operation.dateAbandon) : ''}>{this.state.operation.dateAbandon !== null ? 'Abandon' : ''}</div>
                            </div>
                        </div>
                        <div className="ms-Grid-row divEncartIdentificationSecondaire divEncartIdentificationSecondaireOperation">
                            {/* Sous-titre */}
                            <div className="ms-Grid-col ms-sm12">
                                <div className="ms-Grid-row">
                                    <Stack horizontal horizontalAlign="space-between" className="sousTitreEncart">
                                        {this.state.operation.nomCommercial}
                                        <IconButton name="btnEditOperation" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentification} />
                                    </Stack>
                                </div>
                            </div>
                            {/* Image */}
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <img src={this.state.photo !== null ? this.state.photo.src : perspectiveDefaut} alt={this.state.photo !== null ? this.state.photo.altText : ""} className="imgIdentificationOperation" />
                                </div>
                            </div>
                            {/* Sections : adminitif + énergétique */}
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md6">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 titreEncart">Administratif</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Contact EI :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.loginContactEI}</div>
                                    </div>
                                    {/*<div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur opérationnel :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.directeurOperationnel}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur programme :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.directeurProgramme}</div>
                                    </div>*/}
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Responsable programme :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.responsableProgramme}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Activation des espaces clients :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.activationCapsuleClient === true ? 'Oui' : 'Non'}</div>
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 titreEncart">Energétique</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Perf. énergétiques :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.perfEnergetiques}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Certification :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.certification}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Type de chauffage :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.typeChauffage}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Nature chauffage :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.natureChauffage}</div>
                                    </div>
                                </div>
                            </div>
                            {/* Saut de ligne */}
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 separateur" />
                            </div>
                            {/* Sections : fiscalité + gestion */}
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md6">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 titreEncart">Fiscalité</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">TVA :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">
                                            {!!listTva && Array.isArray(listTva) && listTva
                                                .filter(tva => !isNaN(tva.taux))
                                                .sort((a, b) => a.ordre - b.ordre)
                                                .map(tva => `${tva.taux * 100}%`)
                                                .join(" / ")
                                            }
                                        </div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Zone fiscale :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.zoneFiscale}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Prix maitrisé :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.prixMaitrise}</div>
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 titreEncart">Gestion</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Syndic de copropriété :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.syndicCoPro}</div>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">N° compte :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.numeroCompte}</div>
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 separateur" />
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Bilan financier disponible :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{(this.state.operation.bilanFinancierDisponible ? 'Oui' : 'Non')}</div>
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 separateur" />
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Id opération :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.operation.idOperation}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-lg4">
                    {/* Section : planning */}
                    <div className="blocIdentification niveau2">
                        <Stack horizontal horizontalAlign="space-between">
                            <div className="titreEncart">
                                <Icon iconName="Calendar" className="mr-2" />Planning
                            </div>
                            <IconButton name="btnEditPlanning" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationPlanning} />
                        </Stack>
                        {this._renderPlanningOperation()}
                    </div>
                </div>
            </div>
        </div>;
    }

    //_creationSectionIntervenants = () => {
    //    return <Stack className="divEncartIntervenants">
    //        <CommandBar
    //            items={this._getItemsIntervenants()}
    //            overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
    //            farItems={this._getFarItemsIntervenants()}
    //            ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
    //        />
    //        <div className="separateur" />
    //        <div className="ms-Grid">
    //            <div className="ms-Grid-row">
    //                <div className="ms-Grid-col ms-sm12 ms-md6">
    //                    <DetailsList
    //                        items={this.state.listIntervenants}
    //                        columns={this.columns}
    //                        selectionMode={SelectionMode.multiple}
    //                        selection={this._selectionIntervenant}
    //                        isHeaderVisible={false}
    //                    />
    //                </div>
    //                <div className="ms-Grid-col ms-sm12 ms-md6 blocIntervenants">
    //                    <Stack>
    //                        <div className="titreBlocIntervenants">Créer / modifier un intervenant</div>
    //                        <Stack gap={5} horizontal verticalAlign="end">
    //                            <Stack.Item grow>
    //                                <EUIComboBox
    //                                    avecValeurDefaut={false}
    //                                    data-testid="comboCategorie"
    //                                    label="Catégorie"
    //                                    onChange={(event, option) => this._chargementIntervenants(option.key)}
    //                                    options={this.state.optionsCategorieIntervenant}
    //                                    placeholder="Catégorie"
    //                                    selectedKey={this.state.selectedCategorieIntervenant}
    //                                />
    //                            </Stack.Item>
    //                            <IconButton iconProps={{ iconName: 'Add' }} title="Ajouter une catégorie" onClick={() => this._onAffichePanelCategorieIntervenant(null)} />
    //                            <IconButton name="btnEditCategorieIntervenant" iconProps={{ iconName: 'Edit' }} title="Modifier la catégorie" disabled={this.state.selectedCategorieIntervenant === null} onClick={() => this._onAffichePanelCategorieIntervenant(this.state.selectedCategorieIntervenant)} />
    //                        </Stack>
    //                        <Stack gap={5} horizontal verticalAlign="end">
    //                            <Stack.Item grow>
    //                                <EUIComboBox
    //                                    avecValeurDefaut={false}
    //                                    data-testid="comboSociete"
    //                                    label="Société"
    //                                    onChange={(event, option) => this.setState({ selectedIntervenantSociete: option.key, selectedIntervenantPersonne: 0 })}
    //                                    options={this.state.optionsIntervenantSociete}
    //                                    placeholder="Société"
    //                                    selectedKey={this.state.selectedIntervenantSociete}
    //                                />
    //                            </Stack.Item>
    //                            <IconButton name="btnAddSocieteIntervenant" iconProps={{ iconName: 'Add' }} title="Ajouter une société" onClick={() => this._onAffichePanelIntervenantSociete(0)} />
    //                            <IconButton name="btnEditSocieteIntervenant" iconProps={{ iconName: 'Edit' }} title="Modifier la société" disabled={this.state.selectedIntervenantSociete <= 0} onClick={() => this._onAffichePanelIntervenantSociete(this.state.selectedIntervenantSociete)} />
    //                        </Stack>
    //                        <Stack gap={5} horizontal verticalAlign="end">
    //                            <Stack.Item grow>
    //                                <EUIComboBox
    //                                    avecValeurDefaut={false}
    //                                    data-testid="comboIntervenant"
    //                                    label="Intervenant"
    //                                    onChange={(event, option) => this.setState({ selectedIntervenantPersonne: option.key, selectedIntervenantSociete: 0 })}
    //                                    options={this.state.optionsIntervenantPersonne}
    //                                    placeholder="Intervenant"
    //                                    selectedKey={this.state.selectedCategorieIntervenant}
    //                                />
    //                            </Stack.Item>
    //                            <IconButton name="btnAddPersonneIntervenant" iconProps={{ iconName: 'Add' }} title="Ajouter un intervenant" onClick={() => this._onAffichePanelIntervenantPersonne(0)} />
    //                            <IconButton name="btnEditPersonneIntervenant" iconProps={{ iconName: 'Edit' }} title="Modifier l'intervenant" disabled={this.state.selectedIntervenantPersonne <= 0} onClick={() => this._onAffichePanelIntervenantPersonne(this.state.selectedIntervenantPersonne)} />
    //                        </Stack>
    //                        <Stack.Item align="end" className="mt-2">
    //                            <PrimaryButton name="btnEnregistrementIntervenant" text="OK" onClick={this._onEnregistrementIntervenant} />
    //                        </Stack.Item>
    //                    </Stack>
    //                </div>
    //            </div>
    //        </div>
    //    </Stack>;
    //}

    _creationSectionIntervenants = () => <BlocIntervenants
        idOperation={this.state.operation.idOperation}
        intervenants={this.state.listIntervenants}
        onAdd={this._chargementDonnees}
        onRemove={this._chargementDonnees}
    />;

    _creationSectionEcheancier = () => {
        return <DetailsListEcheancier idOperation={this.state.operation.idOperation} />;
    };

    _creationSectionVente = () => {
        return <div className="divEncartVente">
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6 d-flex flex-column">
                        <Stack grow verticalAlign="space-between" verticalFill className="divEncartBulleVente">
                            <Stack>
                                <div className="titreEncart"><Icon iconName="Chat" /> Bulle de vente</div>
                                <div>{this.state.operation.adresseBulleVente} {this.state.operation.complementAdresseBulleVente !== null && this.state.operation.complementAdresseBulleVente}</div>
                                <div>{this.state.operation.cpBulleVente} {this.state.operation.villeBulleVente}</div>
                                <div className="separateur" />
                                <div>Horaires d'ouverture : {this.state.operation.horaireOuvertureBulleVente}</div>
                                <div className="separateur" />
                                <div className="labelInterlocuteurBulleVente">Interlocuteur : {this.state.operation.interlocuteurBulleVente}</div>
                                <div className="labelInterlocuteurBulleVente">Email : {this.state.operation.emailBulleVente}</div>
                                <div className="labelInterlocuteurBulleVente">Tél : {this.state.operation.telBulleVente}</div>
                            </Stack>
                            <Stack.Item align="end">
                                <IconButton name="btnEditBulleVente" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationVente} />
                            </Stack.Item>
                        </Stack>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 d-flex flex-column">
                        <Stack grow verticalAlign="space-between" verticalFill className="divEncartCommercial">
                            <Stack>
                                <div className="titreEncartCommercial">Forces :</div>
                                <div className="divTexteForcesFaiblesses">{this.state.operation.forces}</div>
                                <div className="separateur" />
                                <div className="titreEncartCommercial">Faiblesses :</div>
                                <div className="divTexteForcesFaiblesses">{this.state.operation.faiblesses}</div>
                            </Stack>
                            <Stack.Item align="end">
                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationVente} />
                            </Stack.Item>
                        </Stack>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6 d-flex flex-column">
                        <Stack grow verticalAlign="space-between" verticalFill className="divEncartCommercial">
                            <Stack>
                                <div className="titreEncartCommercial">Descriptif commercial :</div>
                                <div className="divTexteEncartCommercial">{this.state.operation.descriptifCommercial}</div>
                            </Stack>
                            <Stack.Item align="end">
                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationVente} />
                            </Stack.Item>
                        </Stack>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 d-flex flex-column">
                        <Stack grow verticalAlign="space-between" verticalFill className="divEncartCommercial">
                            <Stack>
                                <div className="titreEncartCommercial">Flash commercial :</div>
                                <div className="divTexteEncartCommercial">{this.state.operation.flashCommercial}</div>
                            </Stack>
                            <Stack.Item align="end">
                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelIdentificationVente} />
                            </Stack.Item>
                        </Stack>
                    </div>
                </div>
            </div>
        </div>;
    }

    _creationSectionDemandes = () => {
        return <DetailsListDemande idOperation={this.state.operation.idOperation} />;
    };

    _onSelectionOnglet = (onglet) => () => {
        this.setState({
            affichageIdentification: false,
            affichageIntervenants: false,
            affichageEcheancier: false,
            affichageVente: false,
            affichageDemandes: false,
            [`affichage${onglet}`]: true
        });
    };

    //_getItemsIntervenants = () => {
    //    let tableauBoutons = [];

    //    let boutonSupprimerIntervenant = {
    //        key: 'supprimerIntervenant',
    //        name: 'Supprimer',
    //        iconProps: {
    //            iconName: 'Delete'
    //        },
    //        disabled: this._selectionIntervenant.getSelectedCount() < 1,
    //        onClick: () => this._onAfficheDialogIntervenants()
    //    }

    //    tableauBoutons.push(boutonSupprimerIntervenant);

    //    let boutonEnvoiMailIntervenant = {
    //        key: 'envoiMailIntervenant',
    //        name: 'Mail',
    //        iconProps: {
    //            iconName: 'Mail'
    //        },
    //        disabled: this._selectionIntervenant.getSelectedCount() < 1,
    //        onClick: () => this._onEnvoiMailIntervenant()
    //    }

    //    tableauBoutons.push(boutonEnvoiMailIntervenant);

    //    return tableauBoutons;
    //}

    //_getFarItemsIntervenants = () => {
    //    return [
    //        {
    //            key: 'nombreEnregistrement',
    //            name: (this.state.listIntervenants != null ? this.state.listIntervenants.length : 0)
    //        }
    //    ];
    //}

    //_getSelectionIntervenants() {
    //    if (this._selectionIntervenant.getSelectedCount() > 0) {
    //        this.setState({
    //            selectedIntervenants: this._selectionIntervenant.getSelection()
    //        });
    //    }
    //    else {
    //        this.setState({
    //            selectedIntervenants: []
    //        });
    //    }
    //}

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de l\'opération en cours'
        });

        var chargementFicheIdentification = DataOperation._chargementFicheIdentification();

        chargementFicheIdentification.then(responseFetch => {
            if (responseFetch.codeRetour === 1) {
                // Pas d'opération dans le périmètre, on redirige vers la liste des opérations
                this.setState({ redirect: true });
            }
            else {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let retourData = responseFetch.reponseAPIobjet;
                    let stateTemp = {};

                    if (retourData !== null) {

                        const operation = retourData[0];

                        stateTemp.operation = operation;
                        stateTemp.operationCycleCommercial = retourData[17];
                        stateTemp.region = retourData[2];
                        stateTemp.agence = retourData[3];
                        stateTemp.nbLots = retourData[4];
                        stateTemp.nbPkgSS = retourData[5];
                        stateTemp.nbPkgEXT = retourData[6];
                        stateTemp.listTva = retourData[7] || [];
                        stateTemp.prixMaitrise = retourData[8];
                        //stateTemp.listIntervenants = retourData[9];
                        stateTemp.perfEnergetiques = retourData[11];
                        stateTemp.certification = retourData[12];
                        stateTemp.typeChauffage = retourData[13];
                        stateTemp.natureChauffage = retourData[14];
                        stateTemp.typeProgramme = retourData[15];
                        stateTemp.programme = retourData[18] || {};
                        stateTemp.produit = retourData[19];
                        stateTemp.sousProduit = retourData[20];
                        stateTemp.trancheTravaux = retourData[21] || {};
                        stateTemp.typeVente = retourData[22];
                        stateTemp.typeContrat = retourData[23];
                        stateTemp.periodeOuverture = retourData[24];
                        stateTemp.afficherOngletDemandes = retourData[30];
                        stateTemp.afficherOngletChecklist = retourData[30];
                        stateTemp.engagementActualiseNb = retourData[31];
                        stateTemp.engagementActualiseCA = retourData[32];
                        stateTemp.engagementActualiseSurface = retourData[33];

                        let photoOperation = retourData[26];
                        if (photoOperation) {
                            stateTemp.photo = {
                                key: photoOperation.rowGUID,
                                src: `data:image/png;base64,${photoOperation.fileData}`,
                                altText: photoOperation.Nom
                            };
                        }

                        //stateTemp.selectedCategorieIntervenant = null;
                        //stateTemp.selectedIntervenantSociete = 0;
                        //stateTemp.selectedIntervenantPersonne = 0;

                        let listeDesPromisesAExecuter = [];

                        //let chargementIntervenantPersonne = DataIntervenantPersonne._chargementIntervenantPersonneParCategorie(this.state.selectedCategorieIntervenant, this.state.selectedIntervenantSociete, operation.idRegion, operation.idAgence);
                        //listeDesPromisesAExecuter.push(chargementIntervenantPersonne.then(responseFetch => {
                        //    Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsIntervenantPersonne', 'idIntervenantEXTPersonne', 'nom', true);
                        //}));

                        //let chargementIntervenantSociete = DataIntervenantSociete._chargementIntervenantSocieteParCategorie(this.state.selectedCategorieIntervenant, operation.idRegion, operation.idAgence);
                        //listeDesPromisesAExecuter.push(chargementIntervenantSociete.then(responseFetch => {
                        //    Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsIntervenantSociete', 'idIntervenantEXTSociete', 'nom', true);
                        //}));

                        //let chargementCategorieIntervenant = DataCategorieIntervenant._chargementCategorieIntervenantParType(null);
                        //listeDesPromisesAExecuter.push(chargementCategorieIntervenant.then(responseFetch => {
                        //    Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsCategorieIntervenant', 'categorie', 'categorie', false);
                        //}));

                        let chargementCycleOperation = DataOperation._chargementFicheIdentification_CycleOperation(operation.idOperation);
                        listeDesPromisesAExecuter.push(chargementCycleOperation.then(responseFetch => {
                            this._onChargementCycleOperation(responseFetch, this, stateTemp);
                        }));

                        Promise.all(listeDesPromisesAExecuter).then(() => { Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp); });
                    }
                    else {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            }
        });
    }

    _onChargementCycleOperation = (responseFetch, _this, stateTemp) => {
        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

        if (retourVerif === null) {
            let objetData = responseFetch.reponseAPIobjet;
            let listCycleOperationTrav = [];
            let cycleValideLePlusHaut = 0;

            objetData.forEach(function (cycle, index) {
                let estCycleValide = cycle.dateAffichee !== null;
                if (estCycleValide && cycleValideLePlusHaut < cycle.idCycleOperation) {
                    stateTemp.operationCycle = cycle;
                    cycleValideLePlusHaut = cycle.idCycleOperation;
                }

                listCycleOperationTrav.push({
                    numEtape: (index + 1),
                    //icone: (cycle.dateValidationCG !== null ? 'Lock' : (estCycleValide ? 'CompletedSolid' : 'PageRight')),
                    icone: (estCycleValide ? 'CompletedSolid' : 'PageRight'), //MG - 2365 (pour une harmonie)
                    nomEtape: cycle.libelle,
                    sousTitre: (estCycleValide ? Scriba.date().stringDateFormatLong(cycle.dateAffichee) : ''),
                    tooltip: (cycle.modifierLe !== null ? `Mis à jour le ${Scriba.date().stringDateHeureFormatCourt(cycle.modifierLe)}` : ''),
                    onClick: _this._togglePanelCycleOperation(true, cycle.idCycleOperation, false)
                });
            });

            stateTemp.listCycleOperation = listCycleOperationTrav;
        }
        else {
            Immocom.onTraitementErreurAvecState(_this, stateTemp, retourVerif, responseFetch);
        }
    }

    //_chargementIntervenants = (categorie) => {
    //    let listeDesPromisesAExecuter = [];
    //    let stateTemp = {};

    //    stateTemp.selectedCategorieIntervenant = categorie;

    //    var chargementIntervenantPersonne = DataIntervenantPersonne._chargementIntervenantPersonneParCategorie(categorie, this.state.selectedIntervenantSociete, this.state.operation.idRegion, this.state.operation.idAgence);
    //    listeDesPromisesAExecuter.push(chargementIntervenantPersonne.then(responseFetch => {
    //        Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsIntervenantPersonne', 'idIntervenantEXTPersonne', 'nom', true);
    //    }));

    //    var chargementIntervenantSociete = DataIntervenantSociete._chargementIntervenantSocieteParCategorie(categorie, this.state.operation.idRegion, this.state.operation.idAgence);
    //    listeDesPromisesAExecuter.push(chargementIntervenantSociete.then(responseFetch => {
    //        Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsIntervenantSociete', 'idIntervenantEXTSociete', 'nom', true);
    //    }));

    //    Promise.all(listeDesPromisesAExecuter).then(() => { this.setState(stateTemp); });
    //}

    //_onEnregistrementIntervenant = () => {
    //    this.setState({
    //        enCoursDeTraitement: true,
    //        messageEnCoursTraitement: 'Enregistrement de l\'intervenant en cours'
    //    });

    //    let onEnregistrementIntervenant = DataOperation._onEnregistrementIntervenant(this.state.operation.idOperation,
    //        (this.state.selectedIntervenantSociete > 0 ? this.state.selectedIntervenantSociete : this.state.selectedIntervenantPersonne),
    //        (this.state.selectedIntervenantPersonne > 0));

    //    onEnregistrementIntervenant
    //        .then(responseFetch => {
    //            let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

    //            if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
    //                this._chargementDonnees();
    //            }
    //            else {
    //                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
    //            }
    //        });
    //}

    //_onEnvoiMailIntervenant = () => {
    //    var chaineMailTo = "mailto:";
    //    var chaineErreur = "Mail non défini pour :";
    //    var ok = true;

    //    this.state.selectedIntervenants.forEach(function (value) {
    //        let email = value.email;
    //        if (email === null || email === undefined || email === '') {
    //            chaineErreur += "\r" + value.categorie + " : " + value.nom;
    //            ok = false;
    //        }
    //        else {
    //            chaineMailTo += email + ";";
    //        }
    //    });

    //    if (ok) {
    //        window.location.href = chaineMailTo;
    //    }
    //    else {
    //        alert(chaineErreur);
    //    }
    //}

    //_onSuppressionIntervenant = () => {
    //    this.setState({
    //        enCoursDeTraitement: true,
    //        messageEnCoursTraitement: 'Suppression des intervenants en cours'
    //    });

    //    this._onCacheDialogIntervenants();

    //    let onSuppressionIntervenants = DataOperation._onSuppressionIntervenants(this.state.operation.idOperation, this.state.selectedIntervenants);

    //    onSuppressionIntervenants
    //        .then(responseFetch => {
    //            let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

    //            if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
    //                this._chargementDonnees();
    //            }
    //            else {
    //                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
    //            }
    //        });
    //}

    _onAffichePanelIdentification = () => {
        this.setState({
            onAffichePanelIdentification: true,
            onPeutChargerLeComposantFicheIdentification: true
        });
    };

    _onCachePanelIdentification = () => {
        if (this.state.onAffichePanelIdentification) {
            this.setState({
                onAffichePanelIdentification: false,
                onPeutChargerLeComposantFicheIdentification: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelIdentificationVente = () => {
        this.setState({
            onAffichePanelIdentificationVente: true,
            onPeutChargerLeComposantFicheIdentificationVente: true
        });
    };

    _onCachePanelIdentificationVente = () => {
        if (this.state.onAffichePanelIdentificationVente) {
            this.setState({
                onAffichePanelIdentificationVente: false,
                onPeutChargerLeComposantFicheIdentificationVente: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelIdentificationEngagement = () => {
        this.setState({
            onAffichePanelIdentificationEngagement: true,
        });
    };

    _onCachePanelIdentificationEngagement = () => {
        if (this.state.onAffichePanelIdentificationEngagement) {
            this.setState({
                onAffichePanelIdentificationEngagement: false,
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelIdentificationPlanning = () => {
        this.setState({
            onAffichePanelIdentificationPlanning: true,
            onPeutChargerLeComposantFicheIdentificationPlanning: true
        });
    };

    _onCachePanelIdentificationPlanning = () => {
        if (this.state.onAffichePanelIdentificationPlanning) {
            this.setState({
                onAffichePanelIdentificationPlanning: false,
                onPeutChargerLeComposantFicheIdentificationPlanning: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelIdentificationNomenclature = () => {
        this.setState({
            onAffichePanelIdentificationNomenclature: true,
            onPeutChargerLeComposantFicheIdentificationNomenclature: true
        });
    };

    _onCachePanelIdentificationNomenclature = () => {
        if (this.state.onAffichePanelIdentificationNomenclature) {
            this.setState({
                onAffichePanelIdentificationNomenclature: false,
                onPeutChargerLeComposantFicheIdentificationNomenclature: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelElementsContratReservation = () => {
        this.setState({
            onAffichePanelElementsContratReservation: true,
            onPeutChargerLeComposantFicheElementsContratReservation: true
        });
    };

    _onCachePanelElementsContratReservation = () => {
        if (this.state.onAffichePanelElementsContratReservation) {
            this.setState({
                onAffichePanelElementsContratReservation: false,
                onPeutChargerLeComposantFicheElementsContratReservation: false
            });

            this._chargementDonnees();
        }
    };

    //_onAffichePanelCategorieIntervenant = (categorie) => {
    //    this.setState({
    //        selectedCategorieIntervenant: categorie,
    //        onAffichePanelCategorieIntervenant: true
    //    });
    //};

    //_onCachePanelCategorieIntervenant = () => {
    //    if (this.state.onAffichePanelCategorieIntervenant) {
    //        this.setState({ onAffichePanelCategorieIntervenant: false });
    //        this._chargementDonnees();
    //    }
    //};

    //_onAffichePanelIntervenantSociete = (idIntervenant) => {
    //    this.setState({ selectedIntervenantSociete: idIntervenant, onAffichePanelIntervenantSociete: true });
    //};

    //_onCachePanelIntervenantSociete = () => {
    //    if (this.state.onAffichePanelIntervenantSociete) {
    //        this.setState({ onAffichePanelIntervenantSociete: false });
    //        this._chargementDonnees();
    //    }
    //};

    //_onAffichePanelIntervenantPersonne = (idIntervenant) => {
    //    this.setState({
    //        selectedIntervenantPersonne: idIntervenant,
    //        onAffichePanelIntervenantPersonne: true,
    //        onPeutChargerLeComposantFicheIntervenantPersonne: true
    //    });
    //};

    //_onCachePanelIntervenantPersonne = () => {
    //    if (this.state.onAffichePanelIntervenantPersonne) {
    //        this.setState({
    //            onAffichePanelIntervenantPersonne: false,
    //            onPeutChargerLeComposantFicheIntervenantPersonne: false
    //        });

    //        this._chargementDonnees();
    //    }
    //};

    _togglePanelCycleOperation = (isOpen, idCycleOperation, rechargerLesDonnees) => () => {
        this.setState(
            {
                onAffichePanelValidationCycleOperation: isOpen,
                selectedIdCycleOperation: idCycleOperation || 0
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _onAffichePanelCycleCommercial = (idCycleCommercial) => {
        this.setState({ selectedIdCycleCommercial: idCycleCommercial, onAffichePanelValidationCycleCommercial: true });
    };

    _onCachePanelCycleCommercial = () => {
        if (this.state.onAffichePanelValidationCycleCommercial) {
            this.setState({ onAffichePanelValidationCycleCommercial: false });

            this._chargementDonnees();
        }
    };

    //_onAfficheDialogIntervenants = () => {
    //    this.setState({
    //        onAfficheDialogIntervenants: true
    //    });
    //};

    //_onCacheDialogIntervenants = () => {
    //    this.setState({
    //        onAfficheDialogIntervenants: false
    //    });
    //};

    _renderPlanningOperation = () => {
        const renderCell = (origine, key) => {
            var date = this.state[origine][key];
            var title = (() => {
                switch (origine) {
                    case "trancheTravaux": return "Cette date peut être modifée dans la fiche tranche travaux";
                    case "programme": return "Cette date peut être modifée dans l'identification programme";
                    case "operation":
                    default: return date;
                }
            })();
            return <span title={title}>{Scriba.date().stringDateFormatCourt(date)}</span>;
        };

        const columns = [
            { key: "date", name: "Date", fieldName: "date" },
            { key: "prevue", name: "Prévue", onRender: (item) => renderCell(item.origine, item.keyPrevue) },
            { key: "reelle", name: "Réelle", onRender: (item) => renderCell(item.origine, item.keyReelle) },
        ];
        const items = [
            // Ordre défini dans le ticket 1627
            { origine: "programme", date: "Perspective", keyReelle: "datePerspective" },
            { origine: "programme", date: "Développement", keyReelle: "dateDeveloppement" },
            { origine: "programme", date: "Montage", keyReelle: "dateMontage" },
            { origine: "programme", date: "Accord comité promesse terrain", keyReelle: "dateAccordComitePromesse" },
            { origine: "programme", date: "Sign. promesse terrain", keyPrevue: "dateSignaturePromessePrevue", keyReelle: "dateSignaturePromesse" },
            { origine: "trancheTravaux", date: "Dépôt PC", keyPrevue: "dateDepotPCPrevue", keyReelle: "dateDepotPC" },
            { origine: "trancheTravaux", date: "Obtention PC", keyPrevue: "dateObtentionPCPrevue", keyReelle: "dateObtentionPC" },
            { origine: "trancheTravaux", date: "Purge PC", keyPrevue: "datePurgePCPrevue", keyReelle: "datePurgePC" },
            { origine: "programme", date: "Accord comité achat terrain", keyReelle: "dateAccordComiteAchatTerrain" },
            { origine: "operation", date: "Passage en avant-première", keyReelle: "datePassageAvantPremiere" },
            { origine: "operation", date: "Commercialisation", keyPrevue: "dateLancementCommercialisationPrevue", keyReelle: "dateLancementCommercialisation" },
            { origine: "programme", date: "Achat terrain", keyPrevue: "dateAchatTerrainPrevue", keyReelle: "dateAchatTerrain" },
            { origine: "programme", date: "Fin validité sign. promesse terrain", keyPrevue: "dateSignaturePromesseFinValiditePrevue", keyReelle: "dateSignaturePromesseFinValidite" },
            { origine: "trancheTravaux", date: "Accord comité lancement travaux", keyReelle: "dateAccordComiteLancementTravaux" },
            { origine: "trancheTravaux", date: "Signature OS travaux", keyPrevue: "dateSignatureOSTravauxPrevue", keyReelle: "dateSignatureOSTravaux" },
            { origine: "operation", date: "Dépôt pièces notaire", keyPrevue: "dateDepotPieceNotairePrevue", keyReelle: "dateDepotPieceNotaire" },
            { origine: "trancheTravaux", date: "Achèvement", keyPrevue: "dateAchevementPrevue", keyReelle: "dateAchevement" },
            { origine: "operation", date: "Livraison", keyPrevue: "dateLivraisonPrevue", keyReelle: "dateLivraison" },
        ];

        return <DetailsList compact columns={columns} items={items} selectionMode={SelectionMode.none} />;
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._chargementDonnees();
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();

        if (this.state.redirect) {
            return <Redirect to='/Operations/ListeOperations' />;
        } else {
            return <Fragment>

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack verticalFill>
                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />
                    <div className="position-relative h-100">
                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                            {content}
                        </ScrollablePane>
                    </div>
                </Stack>

                <FicheIdentification
                    idOperation={this.state.operation.idOperation}
                    onAffichePanelIdentification={this.state.onAffichePanelIdentification}
                    onEnregistrementFiche={() => this._onCachePanelIdentification()}
                    onAnnuleFiche={() => this._onCachePanelIdentification()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIdentification}
                />

                <FicheIdentificationVente
                    idOperation={this.state.operation.idOperation}
                    onAffichePanelIdentificationVente={this.state.onAffichePanelIdentificationVente}
                    onEnregistrementFiche={() => this._onCachePanelIdentificationVente()}
                    onFermeFicheIdentificationVente={() => this._onCachePanelIdentificationVente()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIdentificationVente}
                />

                <FicheIdentificationEngagement
                    idOperation={this.state.operation.idOperation}
                    isOpen={this.state.onAffichePanelIdentificationEngagement}
                    listOperationTVACas={this.state.listTva}
                    onDismiss={this._onCachePanelIdentificationEngagement}
                    onSave={this._onCachePanelIdentificationEngagement}
                />

                <FicheIdentificationNomenclature
                    listTva={this.state.listTva}
                    idOperation={this.state.operation.idOperation}
                    onAffichePanelIdentificationNomenclature={this.state.onAffichePanelIdentificationNomenclature}
                    onEnregistrementFiche={() => this._onCachePanelIdentificationNomenclature()}
                    onFermeFicheIdentificationNomenclature={() => this._onCachePanelIdentificationNomenclature()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIdentificationNomenclature}
                />

                <FicheIdentificationPlanning
                    listTva={this.state.listTva}
                    idOperation={this.state.operation.idOperation}
                    onAffichePanelIdentificationPlanning={this.state.onAffichePanelIdentificationPlanning}
                    onEnregistrementFiche={() => this._onCachePanelIdentificationPlanning()}
                    onFermeFicheIdentificationPlanning={() => this._onCachePanelIdentificationPlanning()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIdentificationPlanning}
                />

                <FicheElementsContratReservation
                    idOperation={this.state.operation.idOperation}
                    onAffichePanelElementsContratReservation={this.state.onAffichePanelElementsContratReservation}
                    onEnregistrementFiche={() => this._onCachePanelElementsContratReservation()}
                    onAnnuleFiche={() => this._onCachePanelElementsContratReservation()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheElementsContratReservation}
                />

                {/*
                <FicheCategorieIntervenant
                    nomCategorie={this.state.selectedCategorieIntervenant}
                    onAffichePanelCategorieIntervenant={this.state.onAffichePanelCategorieIntervenant}
                    onEnregistrementFiche={() => this._onCachePanelCategorieIntervenant()}
                    onAnnuleFiche={() => this._onCachePanelCategorieIntervenant()}
                />

                <FicheIntervenantSociete
                    idIntervenant={this.state.selectedIntervenantSociete}
                    onAffichePanelIntervenantSociete={this.state.onAffichePanelIntervenantSociete}
                    onEnregistrementFiche={() => this._onCachePanelIntervenantSociete()}
                    onAnnuleFiche={() => this._onCachePanelIntervenantSociete()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIntervenantSociete}
                />

                <FicheIntervenantPersonne
                    idIntervenant={this.state.selectedIntervenantPersonne}
                    onAffichePanelIntervenantPersonne={this.state.onAffichePanelIntervenantPersonne}
                    onEnregistrementFiche={() => this._onCachePanelIntervenantPersonne()}
                    onAnnuleFiche={() => this._onCachePanelIntervenantPersonne()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheIntervenantPersonne}
                />
                */}

                <FicheValidationCycleOperation
                    idCycleOperation={this.state.selectedIdCycleOperation}
                    idOperation={this.state.operation.idOperation}
                    isOpen={this.state.onAffichePanelValidationCycleOperation}
                    onDismiss={this._togglePanelCycleOperation(false, null, false)}
                    onSave={this._togglePanelCycleOperation(false, null, true)}
                />

                <FicheValidationCycleCommercial
                    idOperation={this.state.operation.idOperation}
                    idCycleCommercial={this.state.selectedIdCycleCommercial}
                    onAffichePanelValidationCycleCommercial={this.state.onAffichePanelValidationCycleCommercial}
                    onEnregistrementFiche={() => this._onCachePanelCycleCommercial()}
                    onAnnuleFiche={() => this._onCachePanelCycleCommercial()}
                />

                <FicheChecklistItems_Operation
                    idOperation={this.state.operation.idOperation}
                    isOpen={this.state.onAffichePanelChecklist}
                    onDismiss={() => this.setState({ onAffichePanelChecklist: false })}
                />

                {/*
                <Dialog
                    hidden={!this.state.onAfficheDialogIntervenants}
                    onDismiss={this._onCacheDialogIntervenants}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Suppression des intervenants',
                        subText: 'Etes-vous certain de vouloir supprimer les intervenants sélectionnés ?'
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this._onSuppressionIntervenant()} text="Valider" />
                        <DefaultButton onClick={this._onCacheDialogIntervenants} text="Annuler" />
                    </DialogFooter>
                </Dialog>
                */}

                <ModalOperationDates idOperation={this.state.operation.idOperation} />

            </Fragment>;
        }
    }
}